import { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import logo from '../../Assets/Leave App Logo.jpg';
import classes from "./TopBar.module.css";
import { useCookies } from "react-cookie";
import { Navbar, Dropdown } from "react-bootstrap";
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import { TfiFaceSmile } from "react-icons/tfi";
import Hamburger from "hamburger-react";

function HeaderBar({ setSideBar, hideBarPages, confirmLogout }) {

    const [cookies, removeCookies] = useCookies([]);
    const [username, setUsername] = useState("");
	const [userId, setUserId] = useState("");
    const location = useLocation();

	const [sidebar, setSideBar2] = useState(false);
    const [hamburgerDisplay, setHamburgerDisplay] = useState(true);
		
	function toggleHamburger() {
        if (window.innerWidth <= 768) {
            setSideBar2(!sidebar);
            setSideBar(!sidebar);
            setHamburgerDisplay(!hamburgerDisplay);
        } else {
            setSideBar2(!sidebar);
            setSideBar(sidebar);
            setHamburgerDisplay(!hamburgerDisplay);
        }
	}

	useEffect(() => {
		if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
			setUsername(cookies.USERNAME);
			setUserId(cookies.USER_ID);
		}
	}, [cookies.USER_ID]);
    
    useEffect(() => {
        if (window.innerWidth <= 768) { 
            setSideBar2(false);
            setSideBar(false);
            setHamburgerDisplay(false);
        }
    }, [location]);

    return (
        <>
		    {hideBarPages && hideBarPages.filter((p) => p === window.location.toString()).length > 0 ? null :
            <Navbar>
				<Link to="/Dashboard"><img src={logo} className={classes.logo} alt="logo" /></Link>
				<Hamburger toggled={hamburgerDisplay} toggle={toggleHamburger} size={20}/>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <div className={classes.buttonContainer}>
                    <Dropdown className={classes.logout}>
                        <Dropdown.Toggle variant="logout" id="dropdown-basic" className={classes.dropdownToggle}>
							<TfiFaceSmile className={classes.icon} style={{paddingBottom: '0.5px'}}/>Welcome | <span className={classes.username}>{username}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={classes.DropDownLogOut}>
                            <Dropdown.Item as={Link} to="/profile" className={classes.dropdownItem}>
                                <FaUser className={classes.icon} /> Profile
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={confirmLogout} className={classes.dropdownItem}>
                                <FaSignOutAlt className={classes.icon} /> Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Navbar>}
        </>
    );
}

export default HeaderBar;